(ns ui.components.input.currency
  (:require
   [common.currencies :as currencies]
   [common.util :as cu]
   [reagent.core :as r]
   [ui.components.input.number :as number-input]
   [ui.components.select.select :as select]
   [ui.util :as uu]))

;;it was styled in other branch. Has to be checked

(defn divider
  [_]
  [:div
   {:class ""}])

(defn currency-sym-selector
  [state-atom
   {:keys [value on-change on-focus on-blur]}]
  (let []
    [select/view
     {:value      (get currencies/value-options-by-value value)
      :on-focus   (fn [_e]
                    (swap! state-atom assoc :currency-sym-focused? true)
                    (when (fn? on-focus)
                      (on-focus)))
      :onBlur     (fn [_e]
                    (swap! state-atom dissoc :focus?)
                    (when (fn? on-blur)
                      (on-blur)))
      ;; TODO : tailwind styling ??
      ;:class      (h/<class input-style/currency-select)
      :class      ""
      :on-change  (fn [value _value-opt]
                    (on-change value))
      :options    currencies/value-options
      :style-opts {:menu-max-height "200px"}}]))

;; TODO: Do cleanup and styling
(defn view
  [{:keys [_value _transparent? _on-focus _on-blur _secondary-props _variant]}]
  (let [state-atom (r/atom {})]
    (fn [{:keys [value transparent? on-focus on-blur secondary-props variant] :as props}]
      [:div
       {:class "flex gap-1 overflow-hidden max-w-full group/currency-combo-input"}
       [:div
        {:class "min-w-20 max-w-32 shrink-0"}
        [currency-sym-selector
         secondary-props]]
       [:div
        {:class "grow-[2] flex shrink-0 overflow-hidden"}
        [number-input/view
         (merge
          (dissoc props :secondary-props)
          {:size     1
           ;; TODO: Correct styling for transparent & variants
           :on-focus (fn [_]
                       (swap! state-atom assoc :currency-value-focused? true)
                       (when (fn? on-focus)
                         (on-focus)))
           :on-blur  (fn [_]
                       (swap! state-atom assoc :currency-value-focused? false)
                       (when (fn? on-blur)
                         (on-blur)))
           :class    (uu/cm "peer px-3 text-md rounded placeholder-transparent focus:outline-none focus:ring-0"
                            (if transparent?
                              "bg-transparent disabled:bg-transparent"
                              "text-input-light-text disabled:text-disabled-light-text
                                                                      bg-input-light disabled:bg-disabled-light")
                            (if (not= variant :borderless)
                              "py-2 border border-input-light-border-paler hover:border-input-light-border focus:border-input-light-border"
                              "py-2 border-none focus:border-transparent ")
                            (when-not (cu/blank-value? value)
                              "value"))})]]])))
